import { render, staticRenderFns } from "./Instrument_platform_info.vue?vue&type=template&id=00f3a8c4&"
import script from "./Instrument_platform_info.vue?vue&type=script&lang=js&"
export * from "./Instrument_platform_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports